import thankYouPopup from "./../../marketing/include/thankYouPopup";
import messageUsForm from "./../../marketing/include/messageUsForm";

webix.ui(messageUsForm);
webix.ui(thankYouPopup);

export default {};
